export class Word {
  cat: string;
  val: string;
  id?: number;
  selected?: boolean;
}
